// extracted by mini-css-extract-plugin
export default {"tablet":"kx3dG","singleSlide":"ggLud","mobile":"yFnzD","smallMobile":"CORJD"};